'use strict';

angular.module('far.club')
    .controller('ClubEditController', function ($window, autocomplete, Club, clubEditForm, http) {
        var vm = {
            progress: true,
            submitted: false,
            show_error: false,
            club: null,
            form: {},
            fields: clubEditForm,
            constructor: function (club) {
                if ( club ) {
                    vm.form = Club.get(club, function() {
                        if ( vm.form.country ) {
                            vm.form.country = {
                                name: vm.form.country
                            }
                        }

                        vm.progress = false;
                    });
                } else {
                    vm.form = Club.new({country: {
                        name: 'Россия',
                        id: 150
                    }});
                    vm.progress = false;
                }
            },
            submit: function () {
                if ( vm.submitted ) {
                    return false;
                }

                vm.submitted = true;

                vm.form.save()
                    .then(function (response) {
                        document.location.href=Routing.generate('club_members', {id: response.data.id});
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);
                        
                        vm.submitted = false;
                    });
            }
        };

        vm.fields.$fields.user.uiSelectOptions.onSelect = function(item) {
            if (item) { vm.form.user = item; }
        };
        vm.fields.$fields.avatar.uploader.onSuccessItem= function (item, response) {
            vm.form.avatar = response;
        };

        return vm;
    });